var klaviyo = klaviyo || [];
klaviyo.init({
  account: "QXhpBd",
  platform: "shopify"
});
klaviyo.enable("backinstock",{ 
  trigger: {
    product_page_text: "Notify Me",
    product_page_class: "button button--primary uppercase font-normal tracking-[0.08em] w-full",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: true
  },
  modal: {
    font_family: '"Heebo",sans-serif;',
    headline: "",
    body_content: "Register to receive a notification when this item comes back in stock.",
    email_field_label: "Email",
    button_label: "Notify me when available",
    subscription_success_label: "You&#39;re in! We&#39;ll let you know when it&#39;s back.",
    footer_content: '',
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#232320",
    button_text_color: "#fff",
    button_background_color: "#232320",
    close_button_color: "#232320",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500",
    additional_styles: "@import url('//morrisonshop.com/cdn/shop/t/355/assets/klaviyo-bis.css?v=56004335011765748501782264677');"
  }
});
